/* Zlatarstvo Gajsek - gumb 'Preberi vec' za dolga SEO besedila v multirow sekciji
 *
 * Besedilo se NE odstrani iz HTML - samo vizualno se skrci (CSS line-clamp),
 * zato SEO ostane nedotaknjen. Google vidi enako besedilo kot prej.
 *
 * POZOR PRI SELEKTORJU:
 * Razred .image-with-text__text imata v multirow sekciji DVA elementa:
 *   - kratek nadnaslov -> .image-with-text__text--caption
 *   - dolgo besedilo   -> .image-with-text__text.rte.body
 * Ciljamo samo dolgo besedilo. Prva razlicica te skripte je zajela oboje
 * in ustvarila 8 gumbov namesto 4 - tudi pod vsakim kratkim nadnaslovom.
 *
 * Razred in gumb dodamo vedno; ali sta vidna, odloca CSS (samo do 749px).
 * Tako deluje pravilno tudi, ce uporabnik obrne telefon ali spremeni okno.
 */
(function () {
  var MIN_CHARS = 200; /* pod tem se skrajsanje ne splaca */

  function setup() {
    var texts = document.querySelectorAll(
      '[id*="__multirow"] .image-with-text__text.rte.body'
    );
    if (!texts.length) return;

    Array.prototype.forEach.call(texts, function (el, i) {
      if (el.dataset.seoReadmoreReady === '1') return;

      /* Kratkih besedil ne skrajsujemo - gumb bi bil odvec. */
      if ((el.textContent || '').trim().length < MIN_CHARS) return;

      el.dataset.seoReadmoreReady = '1';
      el.classList.add('seo-clamped');

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'seo-readmore';
      btn.textContent = 'Preberi več';
      btn.setAttribute('aria-expanded', 'false');

      if (!el.id) el.id = 'seo-text-' + i;
      btn.setAttribute('aria-controls', el.id);

      el.insertAdjacentElement('afterend', btn);

      btn.addEventListener('click', function () {
        var open = !el.classList.contains('seo-expanded');
        el.classList.toggle('seo-expanded', open);
        el.classList.toggle('seo-clamped', !open);
        btn.textContent = open ? 'Prikaži manj' : 'Preberi več';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
